export default {
  name: "Português",
  pageTitles: {
    home: "Académie AETHERIS — A Clareza ao Serviço da Sua Soberania",
    kit: "Kit Digital Premium — Académie AETHERIS",
    about: "Sobre — Académie AETHERIS",
    services: "O Método — Académie AETHERIS",
    bilan: "Diagnóstico de Soberania Gratuito — Académie AETHERIS",
    merci: "Obrigado — Académie AETHERIS",
  },
  pageDescs: {
    home: "Académie AETHERIS — Revele a arquitetura secreta da sua vida. Método Triple Fusion™: Numerologia, Feng Shui e IFÀ para líderes e empreendedores.",
    kit: "Kit Digital Premium — 67€: o livro «Antes que te tornes», os 12 Decretos Soberanos, o Caderno Soberano e as grelhas Triple Fusion™. Entrega imediata.",
    about: "Rodrigue CASSILDÉ, Arquiteto de Vida e fundador da Académie AETHERIS. O método Triple Fusion™ nascido de 20 anos de pesquisa e terreno.",
    services: "Descubra as ofertas da Académie AETHERIS: Diagnóstico gratuito, Kit Digital 67€, Análises personalizadas e Coaching elite Triple Fusion™.",
    bilan: "Reserve o seu Diagnóstico de Soberania GRATUITO com a Académie AETHERIS. Identifique o que bloqueia a sua trajetória em 24 horas.",
    merci: "Obrigado pela sua encomenda — descarregue as suas 6 ferramentas Triple Fusion™.",
  },
  nav: { home: "Início", method: "O Método", kit: "Kit Digital", about: "Sobre", bilan: "Avaliação Gratuita" },
  hero: {
    eyebrow: "Académie AETHERIS — Arquitetura de Vida",
    titleLines: ["A Clareza ao Serviço", "da Sua Soberania."],
    sub: "Deixe de sofrer o seu destino. Aceda à precisão milenar da fusão IFÀ, Lo Shu e Pitágoras para levantar os seus bloqueios e construir o seu próprio império.",
    ctaPrimary: "Solicite o seu Diagnóstico de Soberania gratuito",
    ctaSecondary: "Descobrir o Método",
  },
  marquee: ["Triple Fusion™", "Numerologia Vibratória", "Feng Shui Tibetano", "Arquitetura de Vida", "Grelha Lo Shu", "Soberania Total", "Dívidas Kármicas"],
  method: {
    label: "O Método Triple Fusion™",
    title: "Três sabedorias milenares, uma trajetória de poder.",
    quote: "PITÁGORAS descodificou os números. Lo Shu descodificou o espaço. IFÀ — Património Imaterial da UNESCO — descodificou o destino. A Triple Fusion™ é o primeiro método a unir estas três sabedorias.",
    cards: [
      { num: "01", name: "IFÀ", tag: "Memória", title: "A memória da sua linhagem", desc: "Sabedoria ancestral reconhecida como Património Imaterial da UNESCO. O IFÀ revela as dívidas da linhagem e os padrões herdados que se repetem na sua vida — para os desativar de vez." },
      { num: "02", name: "Lo Shu", tag: "Espaço", title: "A harmonia do seu ambiente", desc: "A grelha Lo Shu, coração do Feng Shui tibetano, mapeia o seu espaço de vida para que cada direção trabalhe a seu favor, nunca contra si." },
      { num: "03", name: "Pitágoras", tag: "Número", title: "A vibração da sua identidade", desc: "O seu nome e a sua data de nascimento formam uma assinatura vibratória única. Pitágoras descodifica-a para decisões soberanas, tomadas no momento certo." },
    ],
  },
  pathways: {
    label: "Os Caminhos",
    title: "Escolha o grau da sua metamorfose.",
    offers: [
      { id: "diagnostic", name: "Diagnóstico Soberania", price: "Gratuito", features: ["Leitura da sua matriz natal", "Identificação dos seus bloqueios prioritários", "Chamada de restituição de 30 minutos"], cta: "Reservar o meu diagnóstico", to: "bilan" },
      { id: "analyse", name: "Análise Precisão", price: "149€", features: ["Grelha Lo Shu pessoal completa", "Relatório vibratório detalhado", "Recomendações Feng Shui específicas"], cta: "Encomendar a análise", to: "bilan" },
      { id: "pack", name: "Pack Renascimento Quântico", price: "250€", badge: "O mais escolhido", features: ["Inclui a Análise Precisão completa", "Libertação das dívidas kármicas", "Protocolo de reconquista 90 dias"], cta: "Escolher o Renascimento", to: "bilan" },
      { id: "elite", name: "Coaching Elite — Metamorfose", price: "1 950€", features: ["Acompanhamento individual Triple Fusion™", "Arquitetura de Vida completa", "Acesso ao Círculo privado AETHERIS"], cta: "Candidatar-se", to: "bilan" },
    ],
  },
  kitHome: {
    label: "Kit Digital Premium",
    title: "O livro que lhe deveriam ter entregue ao nascer.",
    desc: "Um descodificador de identidade: os seus padrões repetitivos, os bloqueios da sua linhagem, os seus ciclos numéricos — e as chaves concretas para os desativar, um a um.",
    price: "67€",
    cta: "Descobrir o Kit",
  },
  founder: {
    label: "O Fundador",
    name: "Rodrigue Cassildé",
    bio: "Autoridade em Arquitetura de Vida, Numerologia Vibratória e Feng Shui Triple Fusion™. Há 15 anos que guia líderes, empreendedores e construtores de impérios rumo à Soberania Total.",
    cta: "Descobrir o seu percurso",
  },
  finalCta: { title: "O seu império começa com um diagnóstico.", cta: "Solicite o seu Diagnóstico de Soberania gratuito" },
  kit: {
    badges: ["Entrega imediata", "Pagamento seguro — Stripe", "Acesso vitalício"],
    label: "Kit Digital Premium",
    title: "As 6 ferramentas fundadoras da sua reconquista.",
    sub: "Um sistema completo — livro, decretos, caderno, grelhas e carta — para descodificar quem é e retomar o controlo.",
    toolsLabel: "O Conteúdo",
    toolsTitle: "6 ferramentas soberanas, concebidas para serem utilizadas.",
    tools: [
      { name: "ANTES QUE TE TORNES", tag: "O livro fundador" },
      { name: "Os 12 Decretos Soberanos", tag: "Leis de alinhamento" },
      { name: "O Caderno Soberano", tag: "Diário operacional — 90 dias" },
      { name: "A Grelha Guiada Triple Fusion™", tag: "Cartografia pessoal" },
      { name: "O Mapa de Direções Lo Shu", tag: "Bússola do espaço" },
      { name: "A Carta do Fundador", tag: "Mensagem pessoal de Rodrigue Cassildé" },
    ],
    bookLabel: "O Livro Fundador",
    bookTitle: "Antes que te tornes — o livro que deverias ter recebido ao nascer.",
    bookCopy: [
      "Ninguém te entregou o manual de instruções. Nem a escola, nem a tua família, nem a sociedade. Aprendeste a funcionar — nunca a descodificar-te.",
      "Este livro é um descodificador de identidade. Cruza a sabedoria do IFÀ, a grelha Lo Shu e os números de Pitágoras para te revelar o que sempre esteve escrito: os teus ciclos, os teus bloqueios, as tuas linhas de força.",
    ],
    bullets: [
      "Os seus padrões repetitivos — e porque regressam sempre",
      "Os bloqueios da sua linhagem — e como desativá-los",
      "Os seus ciclos numéricos pessoais — para decidir no momento certo",
      "A sua cartografia Triple Fusion™ — o seu ponto de partida soberano",
    ],
    ctaTitle: "A sua reconquista começa agora.",
    ctaSub: "Um investimento único de 67€ para receber as 6 ferramentas fundadoras do método Triple Fusion™.",
    buy: "Encomendo o meu Kit — 67€",
    note: "Entrega por email imediatamente após o pagamento.",
    afterLink: "Já encomendou? Aceda aos seus downloads",
  },
  about: {
    label: "Sobre",
    title: "O arquiteto por trás do método.",
    bioLabel: "O Fundador",
    bio: [
      "Rodrigue Cassildé — autoridade em Arquitetura de Vida, Numerologia Vibratória e Feng Shui Triple Fusion™.",
      "Há 15 anos que guia líderes, empreendedores e construtores de impérios rumo à Soberania Total. A sua convicção: ninguém deveria sofrer um destino que não descodificou.",
      "A Académie AETHERIS nasceu dessa convicção — uma casa onde três sabedorias milenares se tornam uma única trajetória de poder.",
    ],
    quote: "PITÁGORAS descodificou os números. Lo Shu descodificou o espaço. IFÀ — Património Imaterial da UNESCO — descodificou o destino. A Triple Fusion™ é o primeiro método a unir estas três sabedorias.",
    valuesLabel: "Valores Cardeais",
    valuesTitle: "O que nunca se negocia.",
    values: [
      { num: "01", name: "Excelência", desc: "Sem compromissos. Cada análise, cada protocolo, cada palavra é entregue com a mesma exigência — a sua trajetória merece o melhor das três sabedorias." },
      { num: "02", name: "Soberania", desc: "Mestre do seu destino. Não criamos dependência: transmitimos as chaves para que nunca mais sofra." },
      { num: "03", name: "Discrição", desc: "Elite, confidencial. A sua matriz, os seus bloqueios, as suas decisões — tudo o que se diz aqui, aqui fica." },
    ],
    legalLabel: "Estrutura Legal",
    legal: "A Académie AETHERIS opera sob a Synergie VITA Holding (SVH), SAS com capital de 500€, registada no RCS Fort-de-France sob o SIREN 108849241.",
    ctaTitle: "Pronto para conhecer a sua matriz?",
    cta: "Solicite o seu Diagnóstico de Soberania gratuito",
  },
  services: {
    label: "Os Nossos Serviços",
    title: "Um caminho para cada grau de Soberania.",
    sub: "Do primeiro diagnóstico à mentoria de elite, cada caminho é um degrau. Escolha o seu.",
    offers: [
      { id: "diagnostic", name: "Diagnóstico Soberania", price: "Gratuito", desc: "O ponto de partida. 30 minutos para ler a sua matriz e nomear o que o bloqueia.", features: ["Leitura da sua matriz natal", "Identificação dos seus bloqueios prioritários", "Chamada de restituição de 30 minutos"], cta: "Reservar o meu diagnóstico", to: "bilan" },
      { id: "kit", name: "Kit Digital Premium", price: "67€", desc: "As 6 ferramentas fundadoras do método Triple Fusion™, entregues de imediato.", features: ["O livro «Antes que te tornes»", "Os 12 Decretos Soberanos", "O Caderno Soberano — 90 dias", "A Grelha Guiada Triple Fusion™"], cta: "Encomendar o Kit", to: "kit" },
      { id: "analyse", name: "Análise Precisão", price: "149€", desc: "A sua cartografia vibratória completa.", features: ["Grelha Lo Shu pessoal completa", "Relatório vibratório detalhado", "Recomendações Feng Shui específicas"], cta: "Encomendar a análise", to: "bilan" },
      { id: "pack", name: "Pack Renascimento Quântico", price: "250€", badge: "O mais escolhido", desc: "A análise, a libertação, o protocolo.", features: ["Inclui a Análise Precisão completa", "Libertação das dívidas kármicas", "Protocolo de reconquista 90 dias"], cta: "Escolher o Renascimento", to: "bilan" },
      { id: "elite", name: "Coaching Elite — Metamorfose", price: "1 950€", desc: "Três meses de mentoria privada com Rodrigue Cassildé.", features: ["Acompanhamento individual Triple Fusion™", "Arquitetura de Vida completa", "Acesso ao Círculo privado AETHERIS"], cta: "Candidatar-se", to: "bilan" },
    ],
  },
  bilan: {
    label: "Diagnóstico de Soberania Gratuito — 30 minutos",
    title: "Sente que algo bloqueia a sua vida — sem saber o quê?",
    sub: "Em 30 minutos, lemos a sua matriz, identificamos os seus bloqueios prioritários e entregamos-lhe um plano de ação concreto. Sem compromisso.",
    benefitsLabel: "Com o que sai",
    benefits: [
      "Uma leitura clara da sua matriz natal",
      "A identificação dos seus bloqueios prioritários",
      "As suas primeiras direções Lo Shu",
      "Um plano de ação concreto e imediato",
    ],
    testimonialsLabel: "Eles deram o passo",
    testimonials: [
      { text: "Numa única chamada, o Rodrigue nomeou o que três anos de terapia apenas tinham roçado. O meu protocolo de 90 dias mudou tudo.", name: "Claire M.", role: "Empresária" },
      { text: "A Análise Precisão leu-me como um livro aberto. Finalmente percebi porque é que os mesmos padrões regressavam — e como lhes pôr fim.", name: "Julien R.", role: "Executivo" },
      { text: "Estava cética. Depois a grelha Lo Shu explicou a minha casa, as minhas escolhas, os meus bloqueios. Nada voltou a ser igual.", name: "Sofia D.", role: "Fundadora" },
    ],
    form: {
      title: "Reserve o seu horário",
      firstNames: "Nomes",
      lastName: "Apelido",
      maidenName: "Nome de solteira (opcional)",
      birthDate: "Data de nascimento",
      sex: "Sexo",
      female: "Mulher",
      male: "Homem",
      email: "Email",
      submit: "Solicitar o meu Diagnóstico gratuito",
      sending: "A enviar…",
      success: "O seu pedido foi recebido. Rodrigue entrará em contacto dentro de 24 horas. Entretanto, também pode reservar diretamente um horário:",
      calendlyButton: "Reservar a minha chamada de acompanhamento (30 min)",
      error: "Algo correu mal. Tente novamente dentro de instantes.",
    },
    quote: { text: "Não está bloqueado. Está simplesmente a funcionar com o manual de instruções errado.", author: "Rodrigue Cassildé" },
  },
  merci: {
    label: "Pedido Confirmado",
    title: "O seu Kit está a caminho.",
    sub: "As suas 6 ferramentas estão a caminho da sua caixa de entrada. Também pode descarregá-las imediatamente abaixo.",
    frOnlyNote: "",
    downloadsLabel: "Os seus downloads",
    note: "Guarde estes links — acesso vitalício.",
    backHome: "Voltar ao início",
  },
  footer: {
    tagline: "Arquitetura de Vida — IFÀ ◆ Lo Shu ◆ Pitágoras",
    navTitle: "Navegação",
    langTitle: "Idioma",
    svh: "Académie AETHERIS — Synergie VITA Holding (SVH), SAS com capital de 500€ — RCS Fort-de-France — SIREN 108849241",
    rights: "© 2026 Académie AETHERIS. Todos os direitos reservados.",
  },
};
